module.exports = __webpack_public_path__ + "static/img/3.8bb44bfb.png";